export const FOOTER_CONSTANTS = {
    PAGE_LINKS: [
        { link: "/", name: "Home" },
        {
            product: "api-and-direct-data-feed", name: "Solutions", childlink: [
                { link: "air-travel", name: "Airline Fare" },
                { link: "other-travel-data", name: "Other Travel Data" }
            ]
        },
        { link: "resources", name: "Resources" },
        { link: "about-us", name: "About" },


    ],
    SOCIAL_LINKS: [],
    TERMS_LINKS: [
        { link: "terms-and-conditions", name: "Terms And Conditions" },
        { link: "contact-us", name: "Contact Us" },
        { link: "privacy-policy", name: "Privicy Policy" }
    ]
}